import React, { useState, useEffect } from 'react';

import {
  Typography,
  Box,
  Grid,
  AppBar,
  Tabs,
  Tab,
  Divider,
} from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';

import Header from 'on_web/components/shared/Menu/Header/Header';
import ReportsBottomNavigation from 'on_web/components/shared/ReportsBottomNavigation/ReportsBottomNavigation';
import PageItemContainer from 'on_web/components/shared/Common/PageItemContainer/PageItemContainer';
import TraitGroupsMenu from 'on_web/components/shared/TraitGroupsMenu/TraitGroupsMenu';
import TraitGroupsAssessmentCard from 'on_web/components/shared/TraitGroupsAssessmentCard/TraitGroupsAssessmentCard';
import BloodTypeAssessmentCard from 'on_web/components/shared/BloodTypeAssessmentCard/BloodTypeAssessmentCard';

import ConditionSummaryList from 'on_web/components/shared/ConditionSummaryList/ConditionSummaryList';
import ReportsOpenTextSection from 'on_web/components/shared/ReportsOpenTextSection/ReportsOpenTextSection';
import DesktopMenu from 'on_web/components/shared/Menu/DesktopMenu/DesktopMenu';
import TraitAccordionList from 'on_web/components/shared/CustomAccordionList/TraitAccordionList';
import { ROUTE_ASSESSMENT_DNA_TRAIT_DETAILS } from 'routes';

import { traitsHeaderBackground } from 'on_web/assets/imageList';
import { BRIGHT_LIGHT_BLUE } from 'colours';

import { useTranslation } from 'react-i18next';

import {
  getDnaMenuItems,
  getDnaMenuItemIndex,
  getDnaGroupCodeByMenuIndex,
} from 'on_web/helpers/menuItems';

import { reportsBottomNavigationOptions } from 'on_web/helpers/redirectHelper';

import useUsersApi from 'on_web/hooks/useUsersApi';
import useCheckScreenSize from 'on_web/hooks/useCheckScreenSize';
import { trackEvent } from 'on_web/helpers/userTrackingEventsHelper';
import ReportsSectionTitleWithBackground from 'on_web/components/shared/ReportsSectionTitleWithBackground/ReportsSectionTitleWithBackground';
import TraitDescription from 'on_web/components/shared/TraitDescription/TraitDescription';
import { userCanSeeFullDna } from 'on_web/helpers/risksHelper';

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`tabpanel-${index}`}
      aria-labelledby={`tab-${index}`}
      {...other}
    >
      {value === index && <Box p={2}>{children}</Box>}
    </div>
  );
}

export default function ReportsTraitGroup(props) {
  const [currentTraitGroupCodeIx, setCurrentTraitGroupCodeIx] = useState(
    props.location.state == null ||
      props.location.state.group == null ||
      props.location.state.hasFullDna == null
      ? 0
      : getDnaMenuItemIndex(
          props.location.state.group,
          props.location.state.hasFullDna
        )
  );
  const [responseDnaBasedRisks, setResponseDnaBasedRisks] = useState(
    props.location.state.dnaBasedRisk
      ? props.location.state.dnaBasedRisks
      : null
  );
  const [responseBloodType, setResponseBloodType] = useState(
    props.location.state.bloodType ? props.location.state.bloodType : null
  );
  const [tabValue, setTabValue] = useState(0);
  const [userGroups, setUserGroups] = useState(undefined);

  const { t } = useTranslation();
  const [isDesktop] = useCheckScreenSize();

  const [{ getSpareAssessments, getUserData }] = useUsersApi();

  useEffect(() => {
    if (
      props.location.state !== undefined &&
      props.location.state.group !== undefined &&
      props.location.state.hasFullDna !== undefined
    ) {
      let traitCodeIx = props.location.state.group;

      if (
        traitCodeIx !==
        getDnaGroupCodeByMenuIndex(
          currentTraitGroupCodeIx,
          props.location.state.hasFullDna
        )
      ) {
        setCurrentTraitGroupCodeIx(getDnaMenuItemIndex(traitCodeIx));
      }
    }

    if (
      props.location.state &&
      props.location.state.dnaBasedRisk &&
      props.location.state.bloodType
    ) {
      setResponseDnaBasedRisks(props.location.state.dnaBasedRisks);
      setResponseBloodType(props.location.state.bloodType);
    } else {
      getSpareAssessments().then(resp => {
        setResponseDnaBasedRisks(resp.dna_based_severity);
        setResponseBloodType(resp.blood_type);
      });
    }
  }, [getSpareAssessments]);

  useEffect(() => {
    getUserData()
      .then(response => {
        if (response && response.groups) {
          setUserGroups(response.groups);
        }
      })
      .catch(() => {});
  }, [getUserData]);

  const getGroups = userGroups => {
    if (responseDnaBasedRisks == null || userGroups == null) {
      return [];
    }

    const respiratoryGroup = responseDnaBasedRisks['respiratory'];
    const cardiacGroup = responseDnaBasedRisks['cardiac'];
    const diabetesGroup = responseDnaBasedRisks['diabetes'];
    const bloodBiomarkersGroup = responseDnaBasedRisks['blood_biomarkers'];

    let groups = [];

    if (userCanSeeFullDna(userGroups)) {
      groups.push({
        name: respiratoryGroup.name.replace(' Predisposition Group', ''),
        code: respiratoryGroup.code,
        description: respiratoryGroup.description,
        traits: respiratoryGroup.traits,
        assessment_level: respiratoryGroup.assessment_level,
        assessment_label: respiratoryGroup.assessment_label,
      });
      groups.push({
        name: cardiacGroup.name.replace(' Predisposition Group', ''),
        code: cardiacGroup.code,
        description: cardiacGroup.description,
        traits: cardiacGroup.traits,
        assessment_level: cardiacGroup.assessment_level,
        assessment_label: cardiacGroup.assessment_label,
      });
      groups.push({
        name: diabetesGroup.name.replace(' Predisposition Group', ''),
        code: diabetesGroup.code,
        description: diabetesGroup.description,
        traits: diabetesGroup.traits,
        assessment_level: diabetesGroup.assessment_level,
        assessment_label: diabetesGroup.assessment_label,
      });
    }

    groups.push({
      name: bloodBiomarkersGroup.name.replace(' Predisposition Group', ''),
      code: bloodBiomarkersGroup.code,
      description: bloodBiomarkersGroup.description,
      traits: bloodBiomarkersGroup.traits,
      assessment_level: bloodBiomarkersGroup.assessment_level,
      assessment_label: bloodBiomarkersGroup.assessment_label,
    });
    groups.push({
      name: 'Blood Type',
      code: 'blood_type',
      type: responseBloodType.type,
      assessment_level: responseBloodType.level,
      typeDescription: responseBloodType.level_label[0],
      riskDescription: responseBloodType.level_label[1],
      explanation: responseBloodType.explanation,
      meaning: responseBloodType.meaning,
      description: responseBloodType.description,
    });

    return groups;
  };

  const getGroupCode = traitGroupCodeIx => {
    return getDnaMenuItems(userCanSeeFullDna(userGroups))[traitGroupCodeIx]
      .code;
  };

  const group =
    responseDnaBasedRisks && responseBloodType && userGroups
      ? getGroups(userGroups).find(
          g => g.code === getGroupCode(currentTraitGroupCodeIx)
        )
      : null;

  const onIconClicked = ix => {
    setCurrentTraitGroupCodeIx(ix);
  };

  const getStateToTransfer = () => {
    return {
      dnaBasedRisks: responseDnaBasedRisks,
      bloodType: responseBloodType,
    };
  };

  const StyledTab = withStyles(theme => ({
    root: {
      flexGrow: 1,
      fontSize: 16,
      fontWeight: 'normal',
      fontStretch: 'normal',
      fontStyle: 'normal',
      lineHeight: 1.1,
      letterSpacing: 'normal',
      textAlign: 'left',
      color: '#2a343f',
      padding: 15,
      textTransform: 'none',
      '&$selected': {
        color: '#ffffff',
        backgroundColor: '#2fb9da',
      },
    },
    selected: {},
  }))(props => <Tab disableRipple {...props} />);

  const getRisksWithLevel = level => {
    if (responseDnaBasedRisks) {
      return responseDnaBasedRisks[
        getGroupCode(currentTraitGroupCodeIx)
      ].traits.filter(item => item.assessment_level === level);
    }
  };

  const tabTitles =
    responseDnaBasedRisks == null ||
    responseBloodType == null ||
    userGroups == null
      ? []
      : [
          t('reporting.common.dnaCategory.firstSection', {
            groupName: group.name,
          }),
          t('reporting.common.dnaCategory.secondSection', {
            groupName: group.name,
          }),
          t('reporting.common.dnaCategory.thirdSection', {
            groupName: group.name,
          }),
        ];

  const handleTabChange = (event, newValue) => {
    trackEvent(
      'Reporting',
      `Tab click ${
        newValue === 2
          ? 'CRITICAL TRAIT RISKS'
          : newValue === 1
          ? 'MODERATE TRAIT RISKS'
          : 'LOW TRAIT RISKS'
      }`
    );
    setTabValue(newValue);
  };

  const getTabPanelContent = (traits, level) => {
    return traits.length > 0 ? (
      <TraitAccordionList traits={traits} />
    ) : (
      <Grid container direction="row" justify="center" alignItems="center">
        <Box padding={2} textAlign="center">
          <Typography>
            {t(`reporting.common.dnaCategory.youDontHaveForLevel${level}`, {
              groupName: group.name,
            })}
          </Typography>
        </Box>
      </Grid>
    );
  };

  const RenderDesktopVersion = () => {
    return (
      <Box>
        <>
          <AppBar
            position="static"
            style={{ backgroundColor: '#ffffff', boxShadow: 'none' }}
          >
            <Tabs
              value={tabValue}
              onChange={handleTabChange}
              aria-label="tabs"
              variant="fullWidth"
              TabIndicatorProps={{
                style: {
                  backgroundColor: BRIGHT_LIGHT_BLUE,
                },
              }}
            >
              {tabTitles.map((tabTitle, ix) => {
                return <StyledTab label={tabTitle} id={`tab-${ix}`} />;
              })}
            </Tabs>
          </AppBar>
          <TabPanel value={tabValue} index={0}>
            {() => {
              return getTabPanelContent(getRisksWithLevel(2), 2);
            }}
          </TabPanel>

          <TabPanel value={tabValue} index={1}>
            {() => {
              return getTabPanelContent(getRisksWithLevel(1), 1);
            }}
          </TabPanel>

          <TabPanel value={tabValue} index={2}>
            {() => {
              return getTabPanelContent(getRisksWithLevel(0), 0);
            }}
          </TabPanel>
        </>
      </Box>
    );
  };

  const getSection = (traits, level) => {
    if (traits.length === 0) {
      return <React.Fragment />;
    }

    return (
      <>
        <ReportsSectionTitleWithBackground
          backgroundImage={traitsHeaderBackground}
          title={tabTitles[level === 2 ? 0 : level === 1 ? 1 : 2]}
        />
        <Box
          style={{
            marginBottom: '60px',
          }}
        >
          <ConditionSummaryList
            conditionSummaries={traits}
            onClick={traitCode => {
              trackEvent('Reporting', `Trait click ${traitCode}`);
              props.history.push({
                pathname: ROUTE_ASSESSMENT_DNA_TRAIT_DETAILS,
                state: {
                  traitGroupCode: getDnaMenuItems(
                    userCanSeeFullDna(userGroups)
                  )[currentTraitGroupCodeIx].code,
                  traitCode: traitCode,
                  groups: getGroups(userGroups),
                  hasFullDna: userCanSeeFullDna(userGroups),
                  ...getStateToTransfer(),
                },
              });
            }}
          />
        </Box>
      </>
    );
  };

  const RenderMobileVersion = () => {
    return (
      <>
        {getSection(getRisksWithLevel(2), 2)}
        {getSection(getRisksWithLevel(1), 1)}
        {getSection(getRisksWithLevel(0), 0)}
      </>
    );
  };

  return (
    <React.Fragment>
      <div style={{ display: 'flex' }}>
        {responseDnaBasedRisks && responseBloodType && userGroups && (
          <DesktopMenu
            id={2}
            submenuId={getDnaGroupCodeByMenuIndex(
              currentTraitGroupCodeIx,
              userCanSeeFullDna(userGroups)
            )}
            stateToTransferOnNavigation={getStateToTransfer()}
            hasDnaProcessed={true}
            hasFullDna={userCanSeeFullDna(userGroups)}
          />
        )}
        <Grid
          container={isDesktop}
          direction="row"
          justify="center"
          alignItems="center"
          style={{
            width: `calc(100% - ${isDesktop ? 300 : 0}px)`,
          }}
        >
          <PageItemContainer>
            <AppBar
              position="sticky"
              style={{
                backgroundColor: '#ffffff',
                boxShadow: 'none',
              }}
            >
              {!isDesktop &&
                responseDnaBasedRisks &&
                responseBloodType &&
                group && (
                  <Header
                    squeeze
                    title={group.name}
                    secondaryHeaderWithBackNavigation
                  />
                )}
              {!isDesktop &&
                responseDnaBasedRisks &&
                responseBloodType &&
                userGroups && (
                  <AppBar
                    position="sticky"
                    style={{
                      backgroundColor: '#ffffff',
                      boxShadow: 'none',
                      borderTop: '1px solid #efefef',
                      borderBottom: '1px solid #efefef',
                    }}
                  >
                    <TraitGroupsMenu
                      selIx={currentTraitGroupCodeIx}
                      onIconClicked={ix => onIconClicked(ix)}
                      items={getDnaMenuItems(userCanSeeFullDna(userGroups))}
                      groups={getGroups(userGroups)}
                    />
                  </AppBar>
                )}
            </AppBar>
            {responseDnaBasedRisks && responseBloodType && userGroups && (
              <>
                <Box
                  style={{
                    borderBottom: '1px Solid #efefef',
                  }}
                >
                  {group.code === 'blood_type' ? (
                    <BloodTypeAssessmentCard
                      isDesktop={isDesktop}
                      riskLevel={group.assessment_level}
                      type={group.type}
                      typeDescription={group.typeDescription}
                      riskDescription={group.riskDescription}
                    />
                  ) : (
                    <TraitGroupsAssessmentCard
                      numberOfHighRiskTraits={getRisksWithLevel(2).length}
                      numberOfModerateRiskTraits={getRisksWithLevel(1).length}
                      groupName={group.name}
                      isDesktop={isDesktop}
                      riskLevel={group.assessment_level}
                      riskLabel={`${group.assessment_label} ${t(
                        'reporting.common.risks.genetic'
                      )}`}
                    />
                  )}
                </Box>
                <Box>
                  <ReportsOpenTextSection
                    paragraphsKeys={[
                      group.code !== 'blood_type'
                        ? group.description
                        : group.explanation,
                    ]}
                  />
                </Box>
                {group.code !== 'blood_type' ? (
                  isDesktop ? (
                    RenderDesktopVersion()
                  ) : (
                    RenderMobileVersion()
                  )
                ) : (
                  <>
                    <Divider />
                    <Box
                      px={2}
                      style={{ marginBottom: '60px', marginTop: '20px' }}
                    >
                      <TraitDescription
                        description={group.description}
                        meaning={group.meaning}
                        name={group.name}
                        isDesktop={isDesktop}
                      />
                    </Box>
                  </>
                )}
              </>
            )}

            <ReportsBottomNavigation
              selected={reportsBottomNavigationOptions.dnaRisk}
              onSelected={val => props.history.push(val)}
            />
          </PageItemContainer>
        </Grid>
      </div>
    </React.Fragment>
  );
}
